import { StatusBarWrapper, PageTitle, GoBackWrapper, GoBackText} from "./StatusBar.styled";
import ViewStateService from "../../../../../services/view-state/ViewStateService";
import { useEffect, useState } from "react";
import { LeftCircleFilled } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";

interface StatusBarProps {

}

const StatusBar: React.FC<StatusBarProps> = (props)=> {

    let navigate = useNavigate();
    let location = useLocation();
   
    let [title, setTitle] = useState(ViewStateService.getInstance().getStatusBarTitle());

    useEffect(()=> {
        if(location.pathname === '/device-management') {
            setTitle('设备列表');
        }

        // load
        let statusBarTitleChangeListener = (statusBarTitle)=> {
            setTitle(statusBarTitle);
        };
        ViewStateService.getInstance().addStatusBarTitleChnageListener(statusBarTitleChangeListener);

        // unload
        return ()=> {
            ViewStateService.getInstance().removeStatusBarTitleChnageListener(statusBarTitleChangeListener);
        }
    }, []);

    let onGoBack = ()=> {
        if(location.key=='default') {
            navigate("/device-management");
        } else {
            navigate(-1);
        }
    }

    const showGoBackButton = () => {
        let subPagePaths = ['/device-management/', '/alarm-events/', '/user-management/'];
        let path = location.pathname;
        for(let subPathPath of subPagePaths) {
            if (path.startsWith(subPathPath)) {
                return true;
            }
        }
        return false;
    };

    return (
        <StatusBarWrapper>
            { showGoBackButton() &&(
            <GoBackWrapper onClick={onGoBack}>
                    <LeftCircleFilled style={{fontSize: '20px'}} />
                    <GoBackText>返回</GoBackText>
            </GoBackWrapper>)}
            <PageTitle>{title}</PageTitle>
        </StatusBarWrapper>
    );
}


export default StatusBar;